{
  "longPressMessage": "Eelvaate avamiseks vajutage pikalt"
}
